import React from 'react';
import { Spinner } from 'reactstrap';

const LoadingSpinner: React.FC = () => {
  return <Spinner className="loading-spinner" color="light"></Spinner>;
};

export default LoadingSpinner;
